const getTimestampValue = (timestamp) => {
  const numericTimestamp = Number(timestamp);

  return Number.isFinite(numericTimestamp) ? numericTimestamp : new Date(timestamp).getTime();
};

export const getHistoryRowKey = (row = {}) => {
  if (row.packet_id !== null && row.packet_id !== undefined && row.packet_id !== "") {
    return `packet:${row.packet_id}`;
  }

  return `fallback:${row.source_id || ""}:${row.packet_type || ""}:${row.source_time || ""}`;
};

export const mergeHistoryRows = (existingRows = [], incomingRows = []) => {
  const rowsById = new Map();

  [...existingRows, ...incomingRows].forEach((row, index) => {
    const baseKey = getHistoryRowKey(row);
    const key = baseKey === "fallback:::" ? `anonymous:${index}:${JSON.stringify(row)}` : baseKey;

    if (!rowsById.has(key)) {
      rowsById.set(key, { row, order: index });
    }
  });

  return [...rowsById.values()]
    .sort((first, second) => {
      const firstTimestamp = getTimestampValue(first.row?.source_time);
      const secondTimestamp = getTimestampValue(second.row?.source_time);
      const timestampDifference = secondTimestamp - firstTimestamp;

      return Number.isNaN(timestampDifference)
        ? first.order - second.order
        : timestampDifference || first.order - second.order;
    })
    .map(({ row }) => row);
};

export const buildChronologicalTrackPoints = (items, deviceId, selectedVehiclePlate) => {
  const trackPoints = [];

  items?.forEach((item) => {
    const position = item?.gps?.position || {
      lat: item?.["gps.position.lat"],
      lng: item?.["gps.position.lng"],
      alt: item?.["gps.position.alt"],
      is_valid: item?.["gps.position.is_valid"],
    };
    if (
      position.lat &&
      position.lng &&
      item?.source_id === deviceId &&
      item?.plate_number === selectedVehiclePlate
    ) {
      trackPoints.push({
        lat: position.lat,
        lng: position.lng,
        alt: position.alt,
        is_valid: position.is_valid,
        plate_number: item.plate_number,
        timestamp: item.source_time,
        direction: item.velocity?.direction ?? item["velocity.direction"],
      });
    }
  });

  return trackPoints.sort(
    (firstPoint, secondPoint) =>
      getTimestampValue(firstPoint.timestamp) - getTimestampValue(secondPoint.timestamp)
  );
};

export const mergeChronologicalTrackPoints = (current = [], loaded = []) =>
  [...new Map([...loaded, ...current].map((point) => [getTimestampValue(point.timestamp), point])).values()]
    .sort((first, second) => getTimestampValue(first.timestamp) - getTimestampValue(second.timestamp));

export const fillMissingSpeeds = (items = []) => {
  const result = [...items];
  let lastKnownSpeed;

  items
    .map((item, index) => ({ item, index }))
    .sort(
      (first, second) =>
        getTimestampValue(first.item?.source_time) - getTimestampValue(second.item?.source_time)
    )
    .forEach(({ item, index }) => {
      const speed = item?.velocity?.speed;
      const hasValidSpeed =
        speed !== null &&
        speed !== undefined &&
        speed !== "" &&
        Number.isFinite(Number(speed));

      if (hasValidSpeed) {
        lastKnownSpeed = speed;
      } else if (lastKnownSpeed !== undefined) {
        result[index] = {
          ...item,
          velocity: {
            ...item?.velocity,
            speed: lastKnownSpeed,
          },
        };
      }
    });

  return result;
};
